<div class="around">
  <i class="fal fa-times close-btn" title="Đóng" (click)="closeModal()"></i>
  <div class="mapboxgl-popup-content light" *ngIf="tableDatas[index]">
    <div class="title">
      <label for="" title="{{ tableDatas[index].ten }}">
        {{ tableDatas[index].ten }}
      </label>
      <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>
    <ngx-simplebar [ngStyle]="{ height: 'calc(' + featureInfoPopupHeight + 'px - 100px)' }">
      <div class="content">
        <div class="container table-content">
          <div class="row {{ i % 2 == 1 ? 'active' : '' }}" *ngFor="let data of tableDatas[index].data; let i = index">
            <div class="col-6 text-right">{{ data.label }}</div>
            <div class="col-6 text-left">{{ data.text }}</div>
          </div>
        </div>
      </div>
    </ngx-simplebar>
    <div class="paging">
      <section class="esri-popup__navigation d-inline-flex float-right">
        <button class="esri-popup__button" title="Xem trang trước" [disabled]="index <= 0" (click)="index = index - 1">
          <span class="esri-popup__icon esri-icon-left-triangle-arrow"></span>
        </button>
        <div class="esri-popup__button esri-popup__feature-menu-button">{{ index + 1 }} / {{ tableDatas.length }}
        </div>
        <button class="esri-popup__button" title="Xem trang sau" [disabled]="index + 1 >= tableDatas.length"
          (click)="index = index + 1">
          <span class="esri-popup__icon esri-icon-right-triangle-arrow"></span>
        </button>
      </section>
    </div>
    <div class="clearfix"></div>
  </div>
</div>
